if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        // BIÉDE product photo close fix v2026-10-22-1
        // A second photo tap closes the viewer; panning, pinching and video controls do not.
        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          this.photoTap = null;
          const image = event.target.closest('.product-media-modal__content > img');
          if (!this.hasAttribute('open') || !event.isPrimary || !image || (window.visualViewport?.scale || 1) > 1.05)
            return;
          this.photoTap = {
            pointerId: event.pointerId,
            image,
            x: event.clientX,
            y: event.clientY,
            startedAt: event.timeStamp,
          };
        });
        this.addEventListener('pointermove', (event) => {
          if (
            this.photoTap &&
            event.pointerId === this.photoTap.pointerId &&
            Math.hypot(event.clientX - this.photoTap.x, event.clientY - this.photoTap.y) > 12
          )
            this.photoTap = null;
        });
        this.addEventListener('pointercancel', () => {
          this.photoTap = null;
        });
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse') return;
          const tap = this.photoTap;
          this.photoTap = null;
          if (
            tap &&
            event.pointerId === tap.pointerId &&
            event.target === tap.image &&
            event.timeStamp - tap.startedAt < 500 &&
            Math.hypot(event.clientX - tap.x, event.clientY - tap.y) <= 12 &&
            (window.visualViewport?.scale || 1) <= 1.05
          )
            this.hide();
        });
      }

      hide() {
        this.photoTap = null;
        super.hide();
      }

      show(opener) {
        this.photoTap = null;
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
